import { render, staticRenderFns } from "./JSelectMaterialModal.vue?vue&type=template&id=38b1b22c&scoped=true"
import script from "./JSelectMaterialModal.vue?vue&type=script&lang=js"
export * from "./JSelectMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./JSelectMaterialModal.vue?vue&type=style&index=0&id=38b1b22c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b1b22c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38b1b22c')) {
      api.createRecord('38b1b22c', component.options)
    } else {
      api.reload('38b1b22c', component.options)
    }
    module.hot.accept("./JSelectMaterialModal.vue?vue&type=template&id=38b1b22c&scoped=true", function () {
      api.rerender('38b1b22c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecgbiz/modal/JSelectMaterialModal.vue"
export default component.exports